<template>
  <div>
    <wc-data-box
      :dark='invoice.is_on_hold ? true : false'
      :color="invoice.is_on_hold ? 'error' : 'grey lighten-4'"
      :title="invoice.is_on_hold ? 'Invoice On Hold' : 'No Holds'"
      :titleIcon="invoice.is_on_hold ? $store.state.icons.dataBox.invoiceHolds.icon : 'mdi-thumb-up'"
      :titleIconColor="invoice.is_on_hold ? '$store.state.icons.dataBox.invoiceHolds.color' : 'grey'"
    >
      <v-card-text>
        <div v-if='invoice.work_order_obj && invoice.work_order_obj.po'>
          <strong>PO:</strong> {{ invoice.work_order_obj.po }}
        </div>
        <div v-if='invoice.is_on_hold && invoice.work_order_obj && invoice.work_order_obj.hold_invoice_reason' class='mt-2'>
          <strong>Invoice Hold reason:</strong> {{ invoice.work_order_obj.hold_invoice_reason }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          small
          :disabled='invoice.archived || invoice.is_uncollectible'
          :color="invoice.is_on_hold ? 'error' : 'grey'"
          :outlined='invoice.is_on_hold ? false : true'
          :depressed='invoice.is_on_hold ? true : false'
          @click='showHoldDialog = true'
        >
          <span v-if='invoice.is_on_hold'>
            Remove hold
          </span>
          <span v-else>
            Put on hold
          </span>
        </v-btn>
      </v-card-actions>
    </wc-data-box>
    <hold-dialog
      :showDialog='showHoldDialog'
      :invoice='invoice'
      @cancel='showHoldDialog = false'
      @closeDialog='closeDialog'
      @updateHold='updateHold'
      @newAction='newAction'
    ></hold-dialog>
  </div>
</template>

<script>
import InvoiceHoldsDialog from '@/modules/accounting/components/invoice/InvoiceHoldsDialog';

export default {
  name: 'invoice-holds',
  props: {
    invoice: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    showHoldDialog: false
  }),
  components: {
    'hold-dialog': InvoiceHoldsDialog
  },
  methods: {
    updateHold (inv) {
      this.$emit('update', this.invoice.id, inv);
      this.showHoldDialog = false;
    },
    closeDialog(){
      this.showHoldDialog = false;
    },
    newAction (tracker) {
      this.$emit('newAction', tracker);
    },
  }
}
</script>
